import React from "react";
import styled from "styled-components";
import { AspectRatio } from "../../../components/AspectRatio";
import { Media } from "../../../components/Media";
import { Card, CardTitle } from "../../../components/Card";
import { ContentEngagement } from "../../../components/ContentEngagement";
const _CharacterCard = ({ media, title, action }) => {
    return (React.createElement(ContentEngagement, { action: action, contentAnalytics: {
            id: title || "character-card",
            title,
            uiType: "character-card",
        } },
        React.createElement(Card, { "data-testid": "character-card" },
            React.createElement(AspectRatio, { ratio: 3 / 4 },
                React.createElement(Media, { media: media })),
            React.createElement(CardTitle, null, title))));
};
export const CharacterCard = styled(_CharacterCard) ``;
//# sourceMappingURL=CharacterCard.js.map